import React from 'react';
import HeroBgAnimation from '../HeroBgAnimation';
import { HeroContainer,
     HeroBg,
     HeroLeftContainer, 
     Img, 
     HeroRightContainer, 
     HeroInnerContainer, 
     TextLoop, 
     Title, 
     Span, 
     SubTitle, 
     SocialMediaIcons, 
     SocialMediaIcon, 
     ResumeButton 
    } 
    from './HeroStyle';

import HeroImg from '../../images/HeroImage.jpg';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';

const HeroSection = () => {
  return (
    <div id="hero">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Title>Hi, I am <br /> {Bio.name}</Title>
            <TextLoop>
              I am a
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            <ResumeButton href={Bio.resume} target="_blank" rel="noopener noreferrer">
              Check Resume
            </ResumeButton>
            <SocialMediaIcons>
              <SocialMediaIcon href="https://github.com/YOUR_USERNAME" target="_blank">
                <i className="fab fa-github"></i>
              </SocialMediaIcon>
              <SocialMediaIcon href="https://linkedin.com/in/YOUR_PROFILE" target="_blank">
                <i className="fab fa-linkedin"></i>
              </SocialMediaIcon>
            </SocialMediaIcons>
          </HeroLeftContainer>

          <HeroRightContainer id="Right">
            <Img src={HeroImg} alt="hero-image" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
